import React from 'react';
import FilterMainCampaign from './FilterMainCampaignConnected';
import Panels from '../Panels'
import Modal from 'react-modal';
import {
  WidgetPieDrillVisits,
  WidgetPieDrillConversion
} from '../../ConnectedWidgets';
import './PanelMarketing.css';

const colorSchemeArray = ["#5053b3", "#8285ff" , "#c1c3ff", "#df5e00", "#ee8800", "#feaf46"]

const drillMaps = {
  'WidgetPieDrillVisits': WidgetPieDrillVisits,
  'WidgetPieDrillConversion': WidgetPieDrillConversion
}

export default class MarketingHomePanel extends Panels {
  constructor(props) {
    super(props);
    this.state = {
      widgets: {
        WidgetVisits: {
          height: 300,
          width: window.innerWidth > 800 ? window.innerWidth * 0.425 : window.innerWidth * 0.9,
          className: window.innerWidth > 800 ? 'zoomedOut' : 'zoomedIn',
          colorScheme: colorSchemeArray,
          onZoom: window.innerWidth > 800 ? this.zoom('WidgetVisits') : null,
          drillClick: (params) => this.setState({ drillData: params, modal: true}),
          title: 'Visits'
        },
        WidgetConversion: {
          height: 300,
          width: window.innerWidth > 800 ? window.innerWidth * 0.525 : window.innerWidth * 0.9,
          className: window.innerWidth > 800 ? 'zoomedOut' : 'zoomedIn',
          colorScheme: colorSchemeArray,
          onZoom: window.innerWidth > 800 ? this.zoom('WidgetConversion') : null,
          drillClick: (params) => this.setState({ drillData: params, modal: true}),
          title: 'Conversion'
        },
        WidgetTableConversion: {
          height: 850,
          width: window.innerWidth * 0.9,
          className: 'zoomedIn',
          onZoom: window.innerWidth > 800 ? this.zoom('WidgetTableConversion') : null,
          title: 'Conversion',
          style: { height: '850px' },
          defaultPageSize: 14
        },
        WidgetDetailedVisits: {
          height: 300,
          width: window.innerWidth * 0.9,
          className: 'zoomedIn',
          onZoom: window.innerWidth > 800 ? this.zoom('WidgetDetailedVisits') : null,
          title: 'Visits Details',
          style: { height: '600px', marginBottom: '20px' },
          colorScheme: colorSchemeArray
        }
      }
    }
  }

  closeModal = () => this.setState({ modal: false })

  render() {
    const DrillComponent = this.state.drillData ? drillMaps[this.state.drillData.widgetType] : <div />
    return (
      <div className="HomePanel">
        <Modal
          isOpen={this.state.modal}
          onRequestClose={this.closeModal}
          contentLabel="Modal"
          style={{content: {
            top: '25%',
            left: '25%',
            bottom: null,
            right: null,
            width: this.state && this.state.drillData && this.state.drillData.widgetType === 'WidgetPieDrillVisits' ? '50%' : null
          }}}
        >
          <DrillComponent
            colorScheme={colorSchemeArray}
            title={this.state.drillData ? this.state.drillData.widgetTitle : ''}
            filters={{
              ...this.state.drillData,
              ...(this.state.drillData ? this.state.drillData.filters : {})
            }}
            close={this.closeModal}
            height={300}
            width={window.innerWidth > 800 ? window.innerWidth * 0.3 : window.innerWidth * 0.9}
            className={window.innerWidth > 800 ? 'zoomedOut' : 'zoomedIn'}
            colorScheme={colorSchemeArray}
          />
        </Modal>
        <div className="panel-content">
          <FilterMainCampaign />
          {this.renderWidgets()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Panels/PanelMarketingComponent/PanelMarketing.js